import { IPerson, PersonService } from '../../../services/person.service';
class EmployeeItemController {

    private employee: IPerson;

    constructor(private PersonService: PersonService) {
        "ngInject";
    }

    public save = () => {
        if (this.employee.id && this.employee.id > 0) {
            this.PersonService.put(this.employee.id, this.employee).then(() => {

            });
        } else {
            this.PersonService.post(this.employee).then(() => {

            });
        }
    }
}

export const employeeItemComponent = {
    bindings: {
        employee: "<"
    },
    controller: EmployeeItemController,
    template: require("./employee.item.html")
};



// WEBPACK FOOTER //
// ./src/app/modules/settings/employee/employee.item.component.ts